export default "__VITE_ASSET__CioNpdwy__"